module.exports = __webpack_public_path__ + "static/about-us-our-specialists-photo-4d0a3f74a8cbd39c2620bc408cc9ebcf.jpg";